export default ({ request }) => ({
  ecomAmzReplenishmentListPendingShipmentApi(data = {}) {
    return request({
      url: '/ecom/amz/replenishment/listPendingShipment',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomShipmentInfoBuildApi(data = {}) {
    return request({
      url: '/ecom/shipment/info/build',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomShipmentInfoListApi(data = {}) {
    return request({
      url: '/ecom/shipment/info/list',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomShipmentInfoListMergeApi(data = {}) {
    return request({
      url: '/ecom/shipment/info/listMerge',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
  ecomShipmentInfoDetailApi(data = {}) {
    return request({
      url: '/ecom/shipment/info/detail',
      method: 'POST',
      data,
      timeout: 30000,
    })
  },
})
